import React from "react";
import ButtonTemplate from './ButtonTemplate';


function getButtonTemplate(rowData, props, actionType, iconType, toDoFunction) {
    return <ButtonTemplate actionType={actionType} iconType={iconType} toDoFunction={e => toDoFunction(rowData, props)} />
}

export default getButtonTemplate;